export default {
      id: "badge-new-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#badge-new",
      toString: function () {
        return this.url;
      }
    }